// // import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

// // export default defineNuxtPlugin(() => {
// //   const api = new WooCommerceRestApi({
// //     url: "https://whitesmoke-termite-709393.hostingersite.com",
// //     consumerKey: "ck_1fa6b979b52ca70f07be3760fb0540b0522d39d9",
// //     consumerSecret: "cs_48a832610a53a1d3e878c43676f410ee5208493e",
// //     version: "wc/v3"
// //   });

// //   console.log("WooCommerce plugin initialized");

// //   return {
// //     provide: {
// //       woo: api
// //     }
// //   };
// // });

// import axios from 'axios';

// export default defineNuxtPlugin(nuxtApp => {
//   // Use `btoa` for Base64 encoding in the browser
//   const base64Credentials = btoa('ck_1fa6b979b52ca70f07be3760fb0540b0522d39d9' + ':' + 'cs_48a832610a53a1d3e878c43676f410ee5208493e');

//   const api = axios.create({
//     baseURL: "https://backend.penpencilbd.com/wp-json/wc/v3/",
//     headers: {
//       'Authorization': `Basic ${base64Credentials}`,
//       'Content-Type': 'application/json',
//     },
//   });

//   // Provide Axios to Nuxt context
//   nuxtApp.provide('axios', api);
// });

